export default __webpack_public_path__ + "static/media/holdBooking.96c92df5.png";